// Copyright (c) Trung Le
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
export const IUpdateManagerToken = new Token('ipechartUpdateManager');
